import { render, staticRenderFns } from "./EEscolhaDisciplinaMesPDFInfantil.vue?vue&type=template&id=13242e20"
import script from "./EEscolhaDisciplinaMesPDFInfantil.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplinaMesPDFInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports